import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageTop10Gobierno.css';

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

const GOB_TOTAL = 11487116;

const GOB_DATA = [
  { pos: 1,  anunciante: 'PRESIDENCIA DE LA REPUBLICA',              inv: 3193321, spots: 18050,  inv6y: [3193321,2483566,1036157,1321976,29983885,20489031] },
  { pos: 2,  anunciante: 'ALCALDIA DEL DISTRITO CENTRAL',            inv: 2267670, spots: 25389,  inv6y: [2267670,4500838,1753141,641036,596795,582440] },
  { pos: 3,  anunciante: 'INSTITUTO DE LA PROPIEDAD',                inv: 2119029, spots: 64849,  inv6y: [2119029,5098783,4930487,6628174,4455451,1123673] },
  { pos: 4,  anunciante: 'PANI',                                     inv: 753048,  spots: 8348,   inv6y: [753048,2281064,6637342,12837242,1133699,213809] },
  { pos: 5,  anunciante: 'CONATEL',                                  inv: 744924,  spots: 7499,   inv6y: [744924,28117,118797,15857,11455,4615] },
  { pos: 6,  anunciante: 'COMISION REGULADORA DE ENERGIA ELECTRICA', inv: 648788,  spots: 4151,   inv6y: [648788,476473,550742,6759,0,4723] },
  { pos: 7,  anunciante: 'INJUPEMP',                                 inv: 420185,  spots: 18252,  inv6y: [420185,282114,168239,156993,99340,25531] },
  { pos: 8,  anunciante: 'PODER JUDICIAL',                           inv: 299340,  spots: 47624,  inv6y: [299340,174845,360148,353002,543809,167521] },
  { pos: 9,  anunciante: 'CNE CONSEJO NACIONAL ELECTORAL',           inv: 295718,  spots: 14093,  inv6y: [295718,18999,13645,20233,603864,0] },
  { pos: 10, anunciante: 'CONGRESO NACIONAL',                        inv: 259062,  spots: 1730,   inv6y: [259062,10493,55235,49024,3447899,2804429] },
];

function Sparkline({ inv6y }) {
  const chronological = [...inv6y].reverse();
  const inv2025 = inv6y[0];
  const inv2020 = inv6y[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 100;
  const h = 32;
  const padX = 3;
  const padY = 4;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  const pctChange = inv2020 > 0
    ? ((inv2025 - inv2020) / inv2020 * 100).toFixed(0)
    : null;

  return (
    <div className="spark-wrap">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <defs>
          <linearGradient id={`sg-gob-${isUp ? 'u' : 'd'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#sg-gob-${isUp ? 'u' : 'd'})`} />
        <polyline points={polyline} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        {(() => {
          const lp = points[points.length - 1].split(',');
          return <circle cx={lp[0]} cy={lp[1]} r="2" fill={color} />;
        })()}
      </svg>
      <span className={`spark-pct ${isUp ? 'spark-up' : 'spark-down'}`}>
        {pctChange !== null ? (isUp ? '+' : '') + pctChange + '%' : 'NEW'}
      </span>
    </div>
  );
}

function PageTop10Gobierno() {
  const navigate = useNavigate();
  const maxInv = GOB_DATA[0].inv;

  return (
    <PageBackground>
      <div className="top10gob-page">
        <header className="top10gob-header">
          <button className="btn-back" onClick={() => navigate('/top-10-origen')}>
            &#8592; Top 10 Origen
          </button>
          <div className="top10gob-title-block">
            <h1 className="top10gob-title">Top 10 Gobierno</h1>
            <p className="top10gob-subtitle">Capital Gobierno &middot; Honduras 2025 &middot; USD &middot; ${formatNumber(GOB_TOTAL)}</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/mixmedio-inversion')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="top10gob-table-wrap">
          <table className="gob-table">
            <thead>
              <tr>
                <th className="gt-pos">#</th>
                <th className="gt-name">Anunciante</th>
                <th className="gt-inv">Valor Mercado</th>
                <th className="gt-pct">%</th>
                <th className="gt-spots">Spots</th>
                <th className="gt-spark">Inv. 6Y</th>
              </tr>
            </thead>
            <tbody>
              {GOB_DATA.map((row, idx) => {
                const pct = (row.inv / GOB_TOTAL) * 100;
                return (
                  <tr key={row.pos} className="gt-row" style={{ animationDelay: `${idx * 0.05}s` }}>
                    <td className="gt-pos">
                      <span className={`gt-pos-badge ${row.pos <= 3 ? 'gt-pos-top3' : ''}`}>
                        {row.pos}
                      </span>
                    </td>
                    <td className="gt-name">
                      <span className="gt-adv-name">{row.anunciante}</span>
                      <div className="gt-bar-bg">
                        <div className="gt-bar" style={{ width: `${(row.inv / maxInv) * 100}%` }}></div>
                      </div>
                    </td>
                    <td className="gt-inv">${formatNumber(row.inv)}</td>
                    <td className="gt-pct">{pct.toFixed(2)}%</td>
                    <td className="gt-spots">{formatNumber(row.spots)}</td>
                    <td className="gt-spark"><Sparkline inv6y={row.inv6y} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop10Gobierno;
